import {CaptchaModel} from 'web-library';
import {useSelector} from 'react-redux';
import {GET_CAPTCHA_SITE_KEY_URL} from '../../constants/apiUrls';
import {GET_CAPTCHA_SITE_KEY_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {selectUsername} from '../../store/appSlice';

export const useGetCaptchaSiteKey = () => {
  const username = useSelector(selectUsername);
  const getCaptchaSiteKey = async () => {
    const res = await axiosClient.get<CaptchaModel>(GET_CAPTCHA_SITE_KEY_URL, {
      params: {username, portalType: 'CP'},
    });

    return res.data;
  };

  return useCustomQuery(GET_CAPTCHA_SITE_KEY_QUERY_KEY, getCaptchaSiteKey);
};
